import React, { FormEvent, ReactElement, useCallback, useState } from 'react';
import { StyledSearchIcon, ClearButton, SearchWrapper, StyledButton, StyledInput } from './SearchBar.styles';
import { getRootUrl } from '@utils/urlHelpers.util';
import { Integrations } from '@static/js/types';
const analytics = require('/static/js/joy');

export type SearchVariant = 'default' | 'secondary';
interface SearchBarProps
  extends Readonly<{
    placeHolder: string;
    submitLabel: string | ReactElement;
    eventName: string;
    searchPath?: string;
    variant?: SearchVariant;
    id: string;
    enabledAmplitude?: boolean;
  }> {}

export const SearchBar: React.FC<SearchBarProps> = ({
  placeHolder,
  submitLabel,
  eventName,
  searchPath = '/shop?s=',
  variant = 'default',
  id,
  enabledAmplitude = false,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      window.location.href = getRootUrl(`${searchPath}${searchTerm}`);
      analytics.segment.sendTelemetryEvent(eventName, { name: 'Search Keywords', value: searchTerm }, undefined, {
        integrations: { [Integrations.Amplitude]: enabledAmplitude },
      });
    },
    [enabledAmplitude, eventName, searchPath, searchTerm]
  );

  return (
    <SearchWrapper onSubmit={handleSubmit}>
      <StyledSearchIcon css={{ fill: '#2C2925', display: variant === 'secondary' ? 'none' : 'block' }} />
      <StyledInput
        onChange={e => setSearchTerm(e.target.value)}
        value={searchTerm}
        type="text"
        placeholder={placeHolder}
        required
        variant={variant}
      />
      {searchTerm && <ClearButton onClick={() => setSearchTerm('')} variant={variant} />}
      <StyledButton className="button" variant={variant} id={`${id}-search-btn`}>
        {submitLabel}
      </StyledButton>
    </SearchWrapper>
  );
};
